export type ProcessTimerTranslations = {
  calculating: string;
  heartBeatError: string;
};

export const processTimerTranslations: ProcessTimerTranslations = {
  calculating: 'Obliczanie...',
  heartBeatError:
    'Wystąpił błąd z połączeniem. Twoje wyniki zostały zapisane. Za chwilę strona zostanie odświeżona.',
};
